import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import SnamLogo from '../../images/snam-logo-white.png';
import { Navbar, NavbarBrand } from 'react-bootstrap';
import NEDNavbarDivider from './NEDNavbarDivider';

const NEDNavbar = ({user}) => {


    return(
        <Navbar expand="lg" className="navbar-background-snam">
                <NavbarBrand>
                    <img
                        src={SnamLogo}
                        width="40"
                        height="40"
                        className="d-inline-block"
                        alt="Snam Logo"
                    />{' '}
                    <span className="align-middle text-white-snam">  E2i </span>
                </NavbarBrand>
            <Navbar.Collapse className="justify-content-end">
                <Navbar.Text className="text-white-snam">
                    {user.givenName} {user.familyName}
                </Navbar.Text>
                <NEDNavbarDivider />
                <Navbar.Text className="text-white-snam">
                    <FontAwesomeIcon icon={faUserCircle} /> {user.userId}
                </Navbar.Text>
            </Navbar.Collapse>
        </Navbar>
    );

};

export default NEDNavbar;
